import { render, staticRenderFns } from "./date-type-editor.vue?vue&type=template&id=6b65de2e&scoped=true&"
import script from "./date-type-editor.vue?vue&type=script&lang=js&"
export * from "./date-type-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b65de2e",
  null
  
)

export default component.exports